import NotificationPopup from "@/types/NotificationPopup.interface"

interface State {
    notificationPopup: NotificationPopup[]
}

const defaults = () => {
    return {
        notificationPopup: []
    }
}

export default {
    state: defaults(),
    mutations: {
        notificationPopupClose (state: State, id: string): void {
            //  Find our notification index with this id
            const idx = state.notificationPopup.findIndex(x => x.id === id)

            //  If index is -1, do nothing
            if (idx === -1) return

            //  Else, remove that element
            state.notificationPopup.splice(idx, 1)
        },
        notificationPopupOpen (state: State, object: NotificationPopup): void {
            state.notificationPopup = state.notificationPopup || []
            state.notificationPopup.push(object)
        }
    },
    actions: {},
    getters: {
        notificationPopup (state: State): NotificationPopup[] {
            return state.notificationPopup
        }
    }
}